import { render, staticRenderFns } from "./ListItemSkeleton.vue?vue&type=template&id=1fd0a96d&"
import script from "./ListItemSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ListItemSkeleton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports